import { ActionType } from "../types/recaptchaTypes";
var InvoiceInitialState = {
    isLoading: false,
    token: '',
};
export var recaptchaReducer = function (state, action) {
    if (state === void 0) { state = InvoiceInitialState; }
    switch (action.type) {
        case ActionType.GET_RECAPTCHA_TOKEN:
            return {
                token: action.payload
            };
        default:
            return state;
    }
};
